import uuid from 'uuid';

const generatePostLogicItemPlaceholder = () => ({
  id: uuid(),
  questionId: null,
  rules: [],
  isExpanded: true,
});

export default generatePostLogicItemPlaceholder;
